import { Icon } from '@chakra-ui/react';
import type { IconProps } from '@chakra-ui/react';

export const CarIcon = (props: Omit<IconProps, 'children' | 'viewBox'>) => (
  <Icon
    fill='none'
    height='100%'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2'
    viewBox='0 0 24 24'
    width='100%'
    {...props}
  >
    <path
      d='M0 0h24v24H0z'
      fill='none'
      stroke='none'
    />
    <path d='M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0' />
    <path d='M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0' />
    <path d='M5 17h-2v-6l2 -5h9l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-6m-6 -6h15m-6 0v-5' />
  </Icon>
);

export default CarIcon;
